/**
 * Judge.me レビュー表示 + 投稿フォーム
 */
(function () {
  var API_URL = 'https://api.judge.me/api/v1/reviews';
  var WRITE_SELECTORS = [
    '[data-dreampiece-judgeme-write]',
    '.jdgm-write-rev-link',
    '.jdgm-rev-widg__summary-stars',
    '.jdgm-rev-widg__summary-text',
  ].join(', ');
  var LOADING_TIMEOUT_MS = 8000;

  function openJudgeMeForm(root) {
    var wrap = root.querySelector('[data-dreampiece-judgeme-form-wrap]');
    if (!wrap) {
      return false;
    }

    wrap.hidden = false;
    wrap.classList.add('is-open');

    var firstInput = wrap.querySelector('input[type="radio"], input[type="text"], textarea, button');
    if (firstInput) {
      firstInput.focus();
    }

    wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    return true;
  }

  function closeJudgeMeForm(root) {
    var wrap = root.querySelector('[data-dreampiece-judgeme-form-wrap]');
    if (!wrap) {
      return;
    }

    wrap.hidden = true;
    wrap.classList.remove('is-open');
  }

  function refreshJudgeMeWidget() {
    if (window.jdgm && typeof window.jdgm.run === 'function') {
      window.jdgm.run();
    }
  }

  function getJudgeMePublicToken() {
    if (window.jdgmSettings && window.jdgmSettings.public_token) {
      return window.jdgmSettings.public_token;
    }

    if (window.jdgm && window.jdgm.publicToken) {
      return window.jdgm.publicToken;
    }

    var config = document.getElementById('judgeme_config');
    if (config && config.textContent) {
      try {
        var parsed = JSON.parse(config.textContent);
        if (parsed.public_token) {
          return parsed.public_token;
        }
      } catch (error) {
        /* ignore */
      }
    }

    return '';
  }

  function hasRenderedWidget(root) {
    return Boolean(
      root.querySelector('.jdgm-rev-widg') ||
      root.querySelector('[data-dreampiece-judgeme-fallback]:not([hidden])')
    );
  }

  function setFormMessage(form, text, isError) {
    var message = form.querySelector('[data-dreampiece-judgeme-form-message]');
    if (!message) {
      return;
    }

    message.hidden = !text;
    message.textContent = text || '';
    message.classList.toggle('is-error', Boolean(isError));
    message.classList.toggle('is-success', Boolean(text) && !isError);
  }

  function bindStarInput(form) {
    var starsWrap = form.querySelector('[data-dreampiece-judgeme-stars]');
    if (!starsWrap || starsWrap.dataset.dreampieceStarsBound === '1') {
      return;
    }

    starsWrap.dataset.dreampieceStarsBound = '1';

    function refreshStars() {
      var checked = form.querySelector('input[name="rating"]:checked');
      var value = checked ? Number(checked.value) : 0;
      starsWrap.querySelectorAll('.dreampiece-judgeme-form-star').forEach(function (star, index) {
        star.classList.toggle('is-active', index < value);
      });
    }

    starsWrap.addEventListener('change', refreshStars);
    refreshStars();
  }

  function bindForm(root) {
    var form = root.querySelector('[data-dreampiece-judgeme-form]');
    if (!form || form.dataset.dreampieceJudgemeFormBound === '1') {
      return;
    }

    form.dataset.dreampieceJudgemeFormBound = '1';
    bindStarInput(form);

    var cancel = root.querySelector('[data-dreampiece-judgeme-form-cancel]');
    if (cancel) {
      cancel.addEventListener('click', function () {
        closeJudgeMeForm(root);
        setFormMessage(form, '', false);
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitReview(root, form);
    });
  }

  function submitReview(root, form) {
    var submitButton = form.querySelector('[data-dreampiece-judgeme-form-submit]');
    var shopDomain = root.dataset.shopDomain || '';
    var productId = form.querySelector('input[name="product_id"]');
    var nameInput = form.querySelector('input[name="name"]');
    var emailInput = form.querySelector('input[name="email"]');
    var bodyInput = form.querySelector('textarea[name="body"]');
    var ratingInput = form.querySelector('input[name="rating"]:checked');
    var successLabel = root.dataset.reviewSuccessLabel || 'レビューを送信しました。反映まで少し時間がかかることがあります。';
    var errorLabel = root.dataset.reviewErrorLabel || '送信に失敗しました。時間をおいて再度お試しください。';

    if (!ratingInput) {
      setFormMessage(form, '評価（星）を選んでね', true);
      return;
    }

    if (!nameInput.value.trim() || !emailInput.value.trim() || !bodyInput.value.trim()) {
      setFormMessage(form, '未入力の項目があるよ', true);
      return;
    }

    if (!shopDomain || !productId) {
      setFormMessage(form, errorLabel, true);
      return;
    }

    var body = bodyInput.value.trim();
    var title = body.length > 40 ? body.slice(0, 40) + '…' : body;

    var payload = new FormData();
    payload.append('shop_domain', shopDomain);
    payload.append('platform', 'shopify');
    payload.append('id', productId.value);
    payload.append('email', emailInput.value.trim());
    payload.append('name', nameInput.value.trim());
    payload.append('rating', ratingInput.value);
    payload.append('title', title);
    payload.append('body', body);

    if (submitButton) {
      submitButton.disabled = true;
    }
    setFormMessage(form, '送信中…', false);

    fetch(API_URL, {
      method: 'POST',
      body: payload,
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('review_submit_failed');
        }
        return response.json().catch(function () {
          return {};
        });
      })
      .then(function () {
        form.reset();
        var starsWrap = form.querySelector('[data-dreampiece-judgeme-stars]');
        if (starsWrap) {
          starsWrap.querySelectorAll('.dreampiece-judgeme-form-star').forEach(function (star) {
            star.classList.remove('is-active');
          });
        }
        setFormMessage(form, successLabel, false);
        refreshJudgeMeWidget();
        loadFallbackReviews(root);
        window.setTimeout(function () {
          closeJudgeMeForm(root);
        }, 1800);
      })
      .catch(function () {
        setFormMessage(form, errorLabel, true);
      })
      .finally(function () {
        if (submitButton) {
          submitButton.disabled = false;
        }
      });
  }

  function renderStars(rating) {
    var value = Math.max(0, Math.min(5, Number(rating) || 0));
    var html = '';
    for (var i = 1; i <= 5; i += 1) {
      html += '<span class="dreampiece-judgeme-fallback-star' + (i <= value ? ' is-active' : '') + '" aria-hidden="true">★</span>';
    }
    return html;
  }

  function renderFallbackReviews(root, reviews, averageRating) {
    var target = root.querySelector('[data-dreampiece-judgeme-fallback]');
    var empty = root.querySelector('[data-dreampiece-judgeme-empty]');
    if (!target) {
      return;
    }

    if (!reviews || !reviews.length) {
      target.hidden = true;
      target.innerHTML = '';
      if (empty) {
        empty.hidden = false;
      }
      syncLoadingState(root);
      return;
    }

    var summary = '';
    if (averageRating) {
      summary =
        '<div class="dreampiece-judgeme-fallback-summary">' +
        '<div class="dreampiece-judgeme-fallback-stars" aria-label="平均評価 ' + averageRating + '">' +
        renderStars(averageRating) +
        '</div>' +
        '<p class="dreampiece-judgeme-fallback-average">' + Number(averageRating).toFixed(1) + ' / 5</p>' +
        '</div>';
    }

    var list = reviews
      .map(function (review) {
        var name = review.reviewer && review.reviewer.name ? review.reviewer.name : review.name || '匿名';
        var body = review.body || review.title || '';
        return (
          '<article class="dreampiece-judgeme-fallback-item">' +
          '<div class="dreampiece-judgeme-fallback-item-head">' +
          '<strong class="dreampiece-judgeme-fallback-name">' + escapeHtml(name) + '</strong>' +
          '<span class="dreampiece-judgeme-fallback-item-stars" aria-label="評価 ' + review.rating + '">' +
          renderStars(review.rating) +
          '</span>' +
          '</div>' +
          (body ? '<p class="dreampiece-judgeme-fallback-body">' + escapeHtml(body) + '</p>' : '') +
          '</article>'
        );
      })
      .join('');

    target.innerHTML = summary + '<div class="dreampiece-judgeme-fallback-list">' + list + '</div>';
    target.hidden = false;
    if (empty) {
      empty.hidden = true;
    }
    syncLoadingState(root);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function loadFallbackReviews(root) {
    if (hasRenderedWidget(root)) {
      syncLoadingState(root);
      return Promise.resolve();
    }

    var shopDomain = root.dataset.shopDomain || '';
    var productId = root.dataset.productId || '';
    var token = getJudgeMePublicToken();

    if (!shopDomain || !productId || !token) {
      return Promise.resolve();
    }

    var url =
      API_URL +
      '?shop_domain=' +
      encodeURIComponent(shopDomain) +
      '&api_token=' +
      encodeURIComponent(token) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&per_page=10';

    return fetch(url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('review_fetch_failed');
        }
        return response.json();
      })
      .then(function (data) {
        if (hasRenderedWidget(root)) {
          return;
        }
        renderFallbackReviews(root, data.reviews || [], data.average_rating);
      })
      .catch(function () {
        /* noop */
      });
  }

  function handleWriteReviewClick(event) {
    var target = event.target.closest(WRITE_SELECTORS);
    if (!target) {
      return;
    }

    var root = target.closest('[data-dreampiece-judgeme]');
    if (!root) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    openJudgeMeForm(root);
  }

  function syncLoadingState(root) {
    if (!root) {
      return;
    }

    var loading = root.querySelector('[data-dreampiece-judgeme-loading]');
    if (!loading) {
      return;
    }

    loading.hidden = hasRenderedWidget(root);
  }

  function finishLoadingWithoutWidget(root) {
    if (hasRenderedWidget(root)) {
      syncLoadingState(root);
      return;
    }

    loadFallbackReviews(root).then(function () {
      if (hasRenderedWidget(root)) {
        syncLoadingState(root);
        return;
      }

      var loading = root.querySelector('[data-dreampiece-judgeme-loading]');
      var empty = root.querySelector('[data-dreampiece-judgeme-empty]');
      if (loading) {
        loading.hidden = true;
      }
      if (empty) {
        empty.hidden = false;
      }
    });
  }

  function runJudgeMe(root) {
    if (window.jdgm && typeof window.jdgm.run === 'function') {
      window.jdgm.run();
    }

    window.requestAnimationFrame(function () {
      syncLoadingState(root);
    });
  }

  function watchWidgetMount(root) {
    var mount = root.querySelector('[data-dreampiece-judgeme-mount]');
    if (!mount || mount.dataset.dreampieceJudgemeWatch === '1') {
      return;
    }

    mount.dataset.dreampieceJudgemeWatch = '1';

    var observer = new MutationObserver(function () {
      syncLoadingState(root);
    });

    observer.observe(mount, { childList: true, subtree: true });
  }

  function initReviewBlock(root) {
    if (!root) {
      return;
    }

    bindForm(root);
    watchWidgetMount(root);
    syncLoadingState(root);
    runJudgeMe(root);

    if (root.dataset.dreampieceJudgemePollBound === '1') {
      return;
    }

    root.dataset.dreampieceJudgemePollBound = '1';

    var attempts = 0;
    var maxAttempts = Math.ceil(LOADING_TIMEOUT_MS / 250);
    var timer = window.setInterval(function () {
      attempts += 1;
      syncLoadingState(root);

      if (hasRenderedWidget(root)) {
        window.clearInterval(timer);
        return;
      }

      if (attempts >= maxAttempts) {
        window.clearInterval(timer);
        finishLoadingWithoutWidget(root);
      }
    }, 250);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-dreampiece-judgeme]').forEach(initReviewBlock);
  }

  function onJudgeMeReady() {
    document.querySelectorAll('[data-dreampiece-judgeme]').forEach(function (root) {
      runJudgeMe(root);
      loadFallbackReviews(root);
    });
  }

  document.addEventListener('click', handleWriteReviewClick, true);

  document.addEventListener('jdgm.doneSetup', onJudgeMeReady);
  document.addEventListener('jdgm.afterRender', onJudgeMeReady);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
    onJudgeMeReady();
  });
})();
